import {api} from '../../api/access-ctrl'
import {
  registerConfig, ROUTE_NAME_OF_DI_PAGE
} from '../../../components/common/di-ding'
import {commonConfig, routeNameOfDi} from '../common'
import Vue from 'vue'
import ButtonDelete from '../../../components/common/buttons/button-delete'
import ButtonAuth from '../../../components/common/buttons/button-auth'
import ButtonAuthNew from '../../../components/common/buttons/button-auth-new'
import uploadLeafletImg from "../../../components/common/img/uploadLeafletImg";
import {nTipFunc, nWarn} from '../../../utils/notice'
import {errorHandler} from '../../../utils/errorHandler'

Vue.component('button-delete', ButtonDelete)
Vue.component('button-auth', ButtonAuth)
Vue.component('button-auth-new', ButtonAuthNew)
Vue.component('upload-leaflet-img', uploadLeafletImg)

export const mapping = {
  personName: {
    label: '姓名',
    width: '80',
  },
  phone: {
    label: '手机号码',
    width: '110',
  },
  deviceName: {
    label: '门禁',
    width: '100',
  },
  yqPicUrl: {
    label: '照片',
    width: '80',
    type: 'personImg',
  },
  handleType: {
    label: '操作类型',
    width: '80',
  },
  status: {
    label: '状态',
    type: 'fontStatus',
    width: '80',
    mapList: {
      map: {
        '0': '成功',
        '1': '失败',
      }
    }
  },
  yqPicStatus: {
    label: '失败原因',
    type: 'fontStatus',
    width: '160',
  },
  authorityTime: {
    label: '下发时间',
    width: '160',
  }
}

const config = {
  breadcrumb: [{
    value: '智慧门禁',
    name: 'accessCtrlDeviceManagementCenter'
  }, {
    value: '授权记录',
  }],
  center: {
    searchTree: {
      searchKey: 'deviceId',
      searchType: 'face'
    },
    opBar: [ // 多少个元素代表多少行
      [ // 仅支持 flex布局
        // {
        //   type: 'search-tree',
        //   label: '设备名称',
        //   searchKey: 'departmentId',
        //   fetchDetail: () => Promise.resolve([])
        //     .then(list => {
        //       list.forEach(it => {
        //         it._value = it.id
        //         it._label = it.name
        //       })
        //       return list
        //     })
        // },
        {
          type: 'search-selector',
          label: '操作类型',
          searchKey: 'handleType',
          fetchDetail: () => Promise.resolve(
            [
              {_value: '人脸下发', _label: '人脸下发'},
              {_value: '人脸删除', _label: '人脸删除'},
            ]
          )
        },
        {
          type: 'search-selector',
          label: '状态',
          searchKey: 'status',
          fetchDetail: () => Promise.resolve(
            [
              {_value: '0', _label: '成功'},
              {_value: '1', _label: '失败'},
            ]
          )
        },
        {
          type: 'button-download',
          label: '导出',
          getDownloadUrl: (requestBody) => api.exportFaceAuthorityStatus(requestBody),
          download: '人脸授权'
        },
        {type: 'input-search', label: '姓名/手机号码', searchKey: 'searchKey'}
      ],
    ],
    table: {
      selectBox: false,
      operations: [{
        renderContent (h, pageType, data, vm) {
          const reAuthorityPic = () => {
            vm.$confirm('是否确认重新下发照片？')
              .then(
                () => {
                  delete data.id
                  delete data.status
                  api.reAuthority(data)
                    .then(nTipFunc('操作成功'))
                    .then(vm.getData)
                },
                () => {
                  console.debug('用户取消了操作')
                }
              )
              .catch(errorHandler('操作失败'))
          }
          if (data.status === '失败') {
            return <a onClick={reAuthorityPic}>重新下发</a>
          }
        }
      }, {
        renderContent (h, pageType, data, vm) {
          if (data.status === '失败') {
            return h('upload-leaflet-img', {
              on: {
                updateAuthorityImage: (val) => {
                  data.yqPicUrl = val
                  delete data.id
                  delete data.status
                  api.updateAuthorityImage(data)
                    .then(nTipFunc('操作成功'))
                    .then(vm.getData)
                }
              }
            })
          }
        }
      }]
    }
  },

  get: requestBody => api.getFaceAuthorityStatus(requestBody),
  delete: strId => api.deleteAuthority(strId),

  mapping
}

registerConfig(routeNameOfDi.APP_CENTER_ACCESS_CTRL_FACE_ISSUE, config)



// WEBPACK FOOTER //
// ./src/view/AccessCtrl/authority/face-issue.js